import { render } from "./SeeBookings.vue?vue&type=template&id=194c5a2c&scoped=true"
import script from "./SeeBookings.vue?vue&type=script&lang=ts"
export * from "./SeeBookings.vue?vue&type=script&lang=ts"

import "./SeeBookings.vue?vue&type=style&index=0&id=194c5a2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-194c5a2c"

export default script